import { useContext } from 'react';
import AuthContext from 'src/contexts/auth-context';

const WithAuth = ({ children, hideWhenLoggedIn }) => {
  const auth = useContext(AuthContext);
  const isLoggedIn = auth.isLoggedIn;

  if (hideWhenLoggedIn && isLoggedIn) {
    return null;
  }

  if (!hideWhenLoggedIn && !isLoggedIn) {
    return null;
  }

  return <>{children}</>;
};

export default WithAuth;
